import { z } from 'zod';

import { MARKETING_CAMPAIGN, TERMS_FIELD } from './registration.constants';

export const registrationStepThreeSchema = () =>
    z.object({
        [MARKETING_CAMPAIGN.name]: z
            .string()
            .min(0, { message: 'registration.step-three.marketing-campaign.min-length.error' })
            .max(50, { message: 'registration.step-three.marketing-campaign.max-length.error' })
            .regex(/.*/, {
                message: 'registration.step-three.marketing-campaign.invalid-characters.error',
            }),

        [TERMS_FIELD.name]: z.boolean().refine((value) => value, {
            message: 'registration.step-one.terms-and-conditions.required.error',
        }),
    });
